export default class hr {
	static translations = {
		labels: {
			logout: 'Odjava',
			profile: 'Profil',
			yourData: 'Vaši podaci',
			rowsPerPage: 'Redaka po stranici:',
			totalRecords: 'Ukupno zapisa:',
			all: 'Svi',
			noResults: 'Nema rezultata.',
			of: 'od',
			from: 'od',
			to: 'do',
			uploadInProgress: 'Slanje u tijeku.',
			new: 'Novo',
			dragdropMultiple: 'Povucite datoteke ovdje',
			dragdropSingle: 'Povucite datoteku ovdje',
			page: 'Stranica',
			additionalFilters: 'Dodatni filteri',
			yes: 'Da',
			memberNew: 'Novi član',
			branchNewDepartment: 'Novi odjel',
			branchNewBranch: 'Novi ogranak',
			branchNewHeadquarters: 'Nova središnjica',
			userManual: 'Korisničke upute',
		},
		modules: {
			login: 'Prijava',
			members: 'Članovi',
			branches: 'Odjeli/Ogranci/Središnjica',
			payments: 'Uplatnice',
			subscriptions: 'Pretplate',
			reports: 'Izvješća',
			settings: 'Postavke',
			codebooks: 'Šifrarnici',
			userAccounts: 'Korisnici',
			newUserAccount: 'Novi korisnik',
			userManual: 'Korisničke upute',
		},
		fields: {
			search: 'Pretraga',
			firstName: 'Ime',
			lastName: 'Prezime',
			email: 'E-mail',
			contactNumber: 'Kontakt broj',
			password: 'Lozinka',
			rememberMe: 'Zapamti prijavu',
			passwordChange: 'Promjena lozinke',
			oldPassword: 'Stara lozinka',
			newPassword: 'Nova lozinka',
			newPasswordConfirmation: 'Ponovljena nova lozinka',
			active: 'Aktivno',
			role: 'Uloga',
			selectHeaders: 'Odaberi stupce',
			name: 'Naziv',
			user: 'Korisnik',
			dateCreated: 'Datum kreiranja',
			deadline: 'Rok',
			amount: 'Iznos',
			upload: 'Jedna datoteka',
			uploadMultiple: 'Više datoteka',
			oib: 'OIB',
			gender: 'Spol',
			dateOfBirth: 'Datum rođenja',
			placeOfBirth: 'Mjesto rođenja',
			nationality: 'Narodnost',
			profession: 'Zvanje',
			qualification: 'Stručna sprema',
			academicTitle: 'Akademsko zvanje',
			occupation: 'Zanimanje',
			note: 'Napomena',
			country: 'Država',
			county: 'Županija',
			city: 'Mjesto',
			zipCode: 'Poštanski broj',
			address: 'Ulica i broj',
			phoneNumber: 'Telefon',
			mobilePhoneNumber: 'Mobitel',
			newsletterSignup: 'Primanje newslettera',
			company: 'Tvrtka/Ustanova',
			membershipId: 'Članski broj',
			membershipStartDate: 'Datum stupanja u članstvo',
			referenceNumber: 'Poziv na broj primatelja',
			membershipType: 'Vrsta članstva',
			membershipSpecialStatus: 'Poseban status',
			membershipStatus: 'Status',
			membershipBranch: 'Odjel/Ogranak',
			magazineBookstoreDelivery: 'Dostava časopisa KNJIŽARA',
			membershipValidUntil: 'Članarina vrijedi do',
			postageValidUntil: 'Poštarina vrijedi do',
			membershipPaidUntil: 'Članarina plaćena do (za inozemstvo)',
			memberWithdrawn: 'Član ispisan',
			memberWithdralDate: 'Datum ispisa',
			memberDeceased: 'Član umro',
			memberDeceaseDate: 'Datum smrti',
			membershipNote: 'Napomena uz članstvo',
			magazine: 'Časopis',
			magazineDelivery: 'Dostava časopisa',
			function: 'Funkcija',
			cardIssued: 'Izdana iskaznica',
			cardIssueDate: 'Datum iskaznice',
			paymentFormByEmail: 'Uplatnica e-mailom',
			paymentNote: 'Napomena o obvezama',
			withdrawnBooksNote: 'Preuzete knjige',
			returnedSubscriptions: 'Vraćene pretplate',
			date: 'Datum',
			person: 'Osoba',
			field: 'Polje',
			oldValue: 'Stara vrijednost',
			newValue: 'Nova vrijednost',
			type: 'Vrsta',
			presidentHead: 'Predsjednik/Pročelnik',
			lastAssemblyDate: 'Zadnja izborna skupština',
			status: 'Status',
			registryNumber: 'Broj u registru udruga',
			iban: 'IBAN(SWIFT)',
			headquarters: 'Sjedište',
			registryEntryDate: 'Datum upisa u registar',
			foundingAssemblyDate: 'Datum osnivačke skupine',
			recordLink: 'Link na zapisnik',
			deliveredRulebook: 'Dostavljena pravila',
			rulebookConfirmed: 'Potvrđena pravila',
			president: 'Predsjednik',
			presidentConfirmation: 'Potvrda predsjednika',
			vicePresidents: 'Potpredsjednici',
			secretary: 'Tajnik',
			mandateExpirationDate: 'Datum prestanka mandata',
			facebook: 'Facebook',
			webSite: 'Web stranica',
			newMessage: 'Nova poruka',
			activityReportLink: 'Link na izvješće o djelatnosti',
			branchSiteLink: 'Link na stranicu OMH',
			contact: 'Kontakt',
			member: 'Član',
			membersStartDate: 'Učlanjenje',
			membersStartDateDropdown: 'Učlanjenje - izbornik',
			membersStartDateRange: 'Učlanjenje - raspon',
			membersEndDate: 'Istek članarine',
			head: 'Pročelnik',
			headConfirmation: 'Potvrda pročelnika',
			literarySecretary: 'Književni tajnik',
			economicSecretary: 'Gospodarski tajnik',
			boardMember: 'Član glavnog odbora',
			masterAssemblyDate: 'Glavna skupština',
			paymentFormDate: 'Datum uplatnice',
			paymentFormReferenceNumber: 'Poziv na broj',
			paymentFormCategory: 'Kategorija',
			paymentForm: 'Uplatnica',
			payment: 'Uplata',
			paymentDate: 'Datum uplate',
			category: 'Datum uplate',
			paymentFormReturned: 'Vraćeno',
			excerptNumber: 'Broj izvoda',
			excerpt: 'Izvod',
			value: 'Vrijednost',
			subscriptionPrivate: 'Privatno',
			subscriptionBranch: 'Ogranak',
			subscriptionBookstore: 'Knjižara',
			subscriptionTotal: 'Ukupno',
			delivery: 'Preuzimanje',
			branch: 'Ogranak/odjel',
			subscription: 'Pretplata',
			pdfDownload: 'Pdf',
			selectAll: 'Odaberi sve',
			deletePayment: 'Uplata',
			subscriptionTitle: 'Naslov',
			subscriptionCollected: 'Preuzeto',
		},
		alerts: {
			deletionQuestion: 'Jeste li sigurni da želite izbrisati ovaj zapis?',
			fileDeletionQuestion: 'Jeste li sigurni da želite izbrisati ovu datoteku?',
			photoDeletionQuestion: 'Jeste li sigurni da želite izbrisati ovu fotografiju?',
			firstNameMissing: 'Niste unijeli ime.',
			lastNameMissing: 'Niste unijeli prezime.',
			emailMissing: 'Niste unijeli e-mail.',
			emailFailFormat: 'Email je neispravan.',
			passwordMissing: 'Niste unijeli lozinku.',
			passwordFailConfirmation: 'Lozinke se ne podudaraju.',
			passwordResetSuccess: 'Nova lozinka poslana je na unesenu e-mail adresu.',
			passwordResetFail: 'Nije pronađen korisnik sa unesenom e-mail adresom.',
			passwordLength: 'Lozinka mora imati minimalno 8 znakova.',
			passwordLetters: 'Lozinka mora imati barem jedno slovo.',
			passwordDigits: 'Lozinka mora imati barem jednu znamenku.',
			passwordOthers: 'Lozinka mora imati barem jedan poseban znak.',
			loginFail: 'Neispravni podaci za prijavu.',
			basicUpdate: 'Promjene spremljene.',
			basicDelete: 'Zapis izbrisan.',
			basicAdd: 'Zapis dodan.',
			basicError: 'Došlo je do greške na poslužitelju.',
			fieldMissing: 'Ovo polje je obavezno',
			deleteError: 'Ovaj zapis ne možete izbrisati.',
			leaveQuestion: 'Jeste li sigurni da želite otići bez spremanja?',
			generatePasswordQuestion: 'Jeste li sigurni da želite generirati novu lozinku ovom korisniku?',
			recordLocked: 'Ovaj zapis je zaključan jer ga uređuje %name%.',
			paymentPreviewSent: 'Primjer emaila je poslan na Vašu email adresu',
			paymentCreated: 'Uplatnice su uspješno kreirane',
			deletePaymentQuestion: 'Jeste li sigurni da želite obrisati ovu uplatu?',
			paymentDeleted: 'Uplata je uspješno obrisana',
		},
		buttons: {
			login: 'Prijava',
			logout: 'Odjava',
			profile: 'Profil',
			new: 'Novo',
			save: 'Spremi',
			edit: 'Uredi',
			add: 'Dodaj',
			cancel: 'Odustani',
			yes: 'Da',
			no: 'Ne',
			ok: 'OK',
			delete: 'Briši',
			back: 'Natrag',
			forgottenPassword: 'Zaboravili ste lozinku?',
			filter: 'Filtriraj',
			cancelFilter: 'Poništi filtriranje',
			all: 'Sve',
			generateNewPassword: 'Pošalji novu lozinku',
			send: 'Pošalji',
			partial: 'Djelomično',
			previousMonth: 'Prethodni mjesec',
			nextMonth: 'Sljedeći mjesec',
			addMember: 'Dodaj člana',
			addDepartment: 'Dodaj odjel',
			addBranch: 'Dodaj ogranak',
			addPaymentForm: 'Dodaj uplatnicu',
			addPayment: 'Dodaj uplatu',
			addXMLPayment: 'Dodaj XMLuplatu',
		},
		tooltips: {
			edit: 'Uredi',
			delete: 'Briši',
			filter: 'Filter',
			logout: 'Logout',
			openInNewTab: 'Otvori u novom tabu',
			excel: 'Excel export',
			resetFilters: 'Poništi filtere',
			additionalFilters: 'Dodatni filteri',
			selectHeaders: 'Odaberi stupce',
			defaultAmounts1: 'Regularna članarina: 20€ (150,69kn).',
			defaultAmounts2: 'Članarina za učenike, studente i umirovljenike 10€ (75,35kn)',
			defaultAmounts3: 'Poštarina: 9,29€ (70kn)',
		},
		tabs: {
			memberPersonalInfo: 'Osobni podaci',
			memberContactInfo: 'Kontakt podaci',
			memberEmploymentInfo: 'Podaci o zaposlenju',
			memberMembershipInfo: 'Podaci o članstvu',
			memberResponsibilities: 'Obveze',
			memberPayments: 'Uplate',
			memberBookstore: 'Knjižara',
			memberEditHistory: 'Povijest promjena',
			branchInfo: 'Informacije',
			branchWork: 'Rad',
			branchMembers: 'Članovi',
			branchHistory: 'Povijest funkcija',
		},
		texts: {
			passwordReset: `Ako ste zaboravili lozinku ovdje možete zatražiti slanje e-maila sa novom lozinkom.`,
		},
	};
}
